import React from "react";

export class Row {

    constructor(cells, rowNumber) {
        this.cells = cells; // Array of Cell instances
        this.rowNumber = rowNumber; // Row number for identification/sorting
        this.originalOrder = rowNumber; // Store the original order of the row
        this.height = cells.reduce((maxHeight, cell) => {
            if (cell.columnDef.style && cell.columnDef.style.height) {
                return Math.max(maxHeight, parseFloat(cell.columnDef.style.height));
            }
            return maxHeight;
        }, 0);
    }

    shouldInclude() {
        // Check if any cell has a filter function and apply it
        return this.cells.every(cell => {
            return !cell.shouldInclude || cell.shouldInclude();
        });
    }

    setRowNumber(rowNumber) {
        this.rowNumber = rowNumber; // Update the row number
        if (this.originalOrder === null || this.originalOrder === undefined) {
            this.originalOrder = rowNumber; // Store the original order if not already set
        }
    }

    key() {
        return `row-${this.rowNumber}`;
    }

    renderCells(compact, aggregationGroups, collapsed) {
        return [...this.cells].sort((a, b) => {
            if (a.columnDef.renderOrder === null && b.columnDef.renderOrder === null) {
                return 0;
            }
            if (a.columnDef.renderOrder === null) {
                return 1; // a is after b
            }
            if (b.columnDef.renderOrder === null) {
                return -1; // b is after a
            }
            return a.columnDef.renderOrder - b.columnDef.renderOrder;
        }).map((cell, idx) => {
            return cell.render(compact, aggregationGroups, collapsed?.[idx]);
        });
    }

    render(compact, aggregationGroups, collapsed) {
        let classNames = ["canold-table-tr"];
        if (this.rowNumber % 2 === 0) {
            classNames.push("even");
        } else {
            classNames.push("odd");
        }
        if (compact) {
            classNames.push("canold-table-tr-compact");
        }
        const props = {
            role: "canold-table-data-row",
            "aria-rowindex": this.rowNumber + 1, // aria-rowindex is 1-based
            className: classNames.join(" ")
        };
        if (this.height > 0) {
            props.style = {height: this.height + "px"}; // Set height if specified
        }
        return (<tr {...props} key={this.key()}>
            {this.renderCells(compact, aggregationGroups, collapsed)}
        </tr>);
    }

    copy() {
        // Create a shallow copy of the row
        const newRow = new Row(this.cells.map(c => c), this.rowNumber);
        newRow.originalOrder = this.originalOrder; // Preserve original order
        newRow.height = this.height; // Preserve height
        return newRow;
    }

}
